import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmDocuments from "./confirm-documents/ConfirmDocuments";
import ConfirmEmail from "./confirm-email/ConfirmEmail";
import SelectLegalType from "./select-legal-type/SelectLegalType";
import CompletedOnboarding from "./completed/CompletedOnboarding";
import HeaderContentNew from "../shared/HeaderContentNew/HeaderContentNew";
import style from "./OnboardingFlow.module.scss";

const OnboardingFlow = ({ user, role }) => {
  const { t } = useTranslation();
  const [isOpenEmail, setIsOpenEmail] = useState(!user.emailConfirmed);
  const [isOpenDocuments, setIsOpenDocuments] = useState(user.emailConfirmed && user.state !== "Confirmed");
  const [isOpenInstruction, setIsOpenInstruction] = useState(false);
  const [selectedLegalType, setSelectedLegalType] = useState(user.legalType || null);
  const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);

  useEffect(() => {
    setIsOpenEmail(!user.emailConfirmed);
    setIsOpenDocuments(user.emailConfirmed && user.state !== "Confirmed");
  }, [user.emailConfirmed, user.state]);

  useEffect(() => {
    setSelectedLegalType(user.legalType || null);
  }, [user.legalType]);

  const handleComplete = () => {
    setIsOnboardingComplete(true);
  };

  const currentStep = user.emailConfirmed ? 2 : 1;
  const stepProps = {
    user,
    isOpenEmail,
    setIsOpenEmail,
    isOpenDocuments,
    setIsOpenDocuments,
    isOpenInstruction,
    setIsOpenInstruction,
    selectedLegalType,
    setSelectedLegalType,
  };

  return (
    <>
      <HeaderContentNew
        title={t("onboardingPage.header.title")}
        displayTitle
        displayReloadBtn={false}
        displayCreateBtn={false}
      />

      {isOnboardingComplete ? (
        <CompletedOnboarding role={role} />
      ) : (
        <div className={style.page}>
          <div className={style.content}>
            <header className={style.greeting}>
              <h1 className={style.greetingTitle}>
                {t("onboardingPage.greeting.title")}, {user.name} {user.surname}!
              </h1>
              <p className={style.greetingText}>{t("onboardingPage.greeting.text")}</p>
            </header>

            <section className={style.verification} aria-labelledby="verification-title">
              <aside className={style.progress}>
                <h2 id="verification-title" className={style.progressTitle}>
                  {t("onboardingPage.verification.title")}
                </h2>
                <ol className={style.steps}>
                  <li
                    className={style.step}
                    data-active={currentStep === 1}
                    data-complete={currentStep > 1}
                  >
                    <span className={style.stepMarker}>1</span>
                    <span className={style.stepCopy}>
                      <span className={style.stepTitle}>{t("onboardingPage.steps.email.title")}</span>
                      <span className={style.stepDescription}>
                        {t("onboardingPage.steps.email.description")}
                      </span>
                    </span>
                  </li>
                  <li className={style.step} data-active={currentStep === 2}>
                    <span className={style.stepMarker}>2</span>
                    <span className={style.stepCopy}>
                      <span className={style.stepTitle}>{t("onboardingPage.steps.documents.title")}</span>
                      <span className={style.stepDescription}>
                        {t("onboardingPage.steps.documents.description")}
                      </span>
                    </span>
                  </li>
                </ol>
              </aside>

              <div className={style.stepPanel}>
                <div className={style.stepLabel}>{t("onboardingPage.stepLabel", { step: currentStep })}</div>
                {currentStep === 1 ? (
                  <ConfirmEmail {...stepProps} />
                ) : (
                  <div className={style.documentsStep}>
                    <SelectLegalType
                      selectedLegalType={selectedLegalType}
                      setSelectedLegalType={setSelectedLegalType}
                    />
                    <ConfirmDocuments {...stepProps} onComplete={handleComplete} />
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default OnboardingFlow;
